export const POLICY_URLs: { [key: string]: Map<string, string> } = {
    topciment: new Map([
        ['de-at', 'nutzungsbedingungen-datenschutz-richtlinie'],
        ['zh-cn', 'tiao-jian-shi-yong-yin-si-zheng-ce'],
        ['zh-tw', 'shi-yong-tiao-jian-yin-si-zheng-ce'],
        ['fr-ch', 'conditions-utilisation-politique-confidentialite'],
        ['es-mx', 'condiciones-uso-politica-privacidad'],
        ['en', 'terms-conditions-and-privacy-statement'],
        ['en-us', 'terms-conditions-and-privacy-statement'],
        ['en-au', 'terms-conditions-and-privacy-statement'],
        ['en-ca', 'terms-conditions-and-privacy-statement'],
        ['en-in', 'terms-conditions-and-privacy-statement'],
        ['ja', 'riyoujouken-puraibashiporishi'],
        ['ko', 'sayong-jogeon-gaeinjeongbo-bohojeongchaek'],
        ['ko', 'sayong-jogeon-gaeinjeongbo-bohojeongchaek'],
        ['fr', 'termes-conditions-et-declaration-de-confidentialite'],
        ['de', 'nutzungsbedingungen-datenschutz-richtlinie'],
        ['es', 'condiciones-uso-politica-privacidad'],
        ['hr', 'uvjeti-koristenje-politika-privatnosti'],
        ['it', 'condizioni-duso-privacy-policy'],
        ['hu', 'feltetelek-hasznalat-adatvedelmi-szabalyzat'],
        ['nl', 'gebruiksvoorwaarden-privacy-beleid'],
        ['no', 'vilkar-bruk-personvernregler'],
        ['pl', 'warunki-wykorzystuja-prywatnosc-polityczna'],
        ['pt', 'condicoes-uso-politica-privacidade'],
        ['ro', 'conditii-utilizare-politica-confidentialitate'],
        ['sl', 'pogoji-uporabe-politika-zasebnosti'],
        ['sk', 'podmienky-pouzitia-politika-sukromia'],
        ['fi', 'kayttoehdot-yksityisyyskaytanto'],
        ['ru', 'usloviya-ispolzovaniya-politika-konfidentsialnosti'],
        ['tr', 'kosullar-kullanım-politikası-gizlilik'],
    ]),
    smartcret: new Map([
        ['en', 'policies/privacy-policy'],
        ['es', 'policies/privacy-policy'],
        ['fr', 'policies/privacy-policy'],
        ['it', 'policies/privacy-policy'],
        ['de', 'policies/privacy-policy'],
    ]),
    luxuryconcrete: new Map([
        ['bg', 'pravna-belezjka'],
        ['cs', 'pravni-poznamka'],
        ['cy', 'cyfraith-nodyn'],
        ['da', 'lovlig-bemaerkning'],
        ['de', 'rechtlicher-hinweis'],
        ['de-ch', 'rechtlicher-Vermerk'],
        ['el', 'nomiki-simeiosi'],
        ['en', 'legal-notice'],
        ['en-us', 'legal-notice'],
        ['es', 'nota-legal'],
        ['et', 'seaduslik-marg'],
        ['fi', 'lakiasiaakirja'],
        ['fr', 'note-legale'],
        ['ga', 'nota-dli'],
        ['he', 'haarah-mishpatit'],
        ['hi', 'kaanoonee-not'],
        ['hr', 'pravna-napomena'],
        ['hu', 'jogi-megjegyzes'],
        ['id', 'catatan-hukum'],
        ['is', 'lagaleg-athugasemd'],
        ['it', 'nota-legale'],
        ['is', 'lagaleg-athugasemd'],
        ['ja', 'nota-ri-garu'],
        ['ko', 'beobjeog-juui'],
        ['ku', 'nota-legal'],
        ['lt', 'teisine-pastaba'],
        ['lv', 'tiesiskas-piezime'],
        ['ml', 'nott-leegal'],
        ['ms', 'nota-hukum'],
        ['mt', 'nota-legali'],
        ['nb', 'juridisk-merknad'],
        ['nl', 'wettelijke-kennisgeving'],
        ['no', 'juridisk-merknad'],
        ['pa', 'nota-legal'],
        ['pl', 'nota-prawna'],
        ['pt', 'nota-legal'],
        ['ro', 'nota-juridica'],
        ['ru', 'yuridicheskaya-zametka'],
        ['sk', 'pravna-poznamka'],
        ['sl', 'pravna-obvestila'],
        ['sq', 'shenim-ligjor'],
        ['sr', 'pravna-beleska'],
        ['sv', 'juridisk-anmarkning'],
        ['tr', 'hukuki-not'],
        ['vi', 'ghi-chu-phap-ly'],
        ['zh-cn', 'fa-lu-tong-zhi'],
    ]),
    meexe: new Map([
        ['es', 'aviso-legal'],
        ['en', 'legal-warning'],
        ['it', 'nota-legale'],
    ]),
    myrevest: new Map([
        ['cs', 'pravni-upozorneni'],
        ['bg', 'praven-savet'],
        ['cy', 'rhybudd-cyfreithiol'],
        ['da', 'juridisk-meddelelse'],
        ['de', 'rechtliche-benachrichtigung'],
        ['de-ch', 'rechtlicher-hinweis'],
        ['el', 'nomike-eidopoisi'],
        ['en', 'legal-notice'],
        ['en-us', 'legal-notice'],
        ['es', 'aviso-legal'],
        ['et', 'oiguslik-teade'],
        ['fi', 'oikeudellinen-ilmoitus'],
        ['fr', 'mention-legale'],
        ['ga', 'folamh-legal'],
        ['hi', 'kaanoonee-soochana'],
        ['hr', 'pravna-obavijest'],
        ['hu', 'jogi-figyelmeztetes'],
        ['id', 'pemberitahuan-hukum'],
        ['is', 'loglegt-tilkynning'],
        ['it', 'avviso-legale'],
        ['ja', 'regaru-nootisu'],
        ['ko', 'beobjeog-goji'],
        ['lt', 'teisine-informacija'],
        ['ms', 'notis-undang-undang'],
        ['nb', 'juridisk-merknad'],
        ['nl', 'wettelijke-kennisgeving'],
        ['no', 'juridisk-merknad'],
        ['pl', 'prawne-ostrzezenie'],
        ['pt', 'aviso-legal'],
        ['ro', 'avertisment-legal'],
        ['ru', 'yuridicheskoe-uvedomlenie'],
        ['sk', 'legalne-upozornenie'],
        ['sl', 'pravno-obvestilo'],
        ['sq', 'njoftim-juridik'],
        ['sr', 'pravna-obavestenja'],
        ['sv', 'rattsligt-meddelande'],
        ['tr', 'yasal-uyari'],
        ['vi', 'thong-bao-phap-luat'],
        ['zh-cn', 'fa-lu-tong-zhi'],
    ]),
    aplicadormicrocemento: new Map([['es', 'politica-privacidad']]),
    hormigonimpres: new Map([['es', 'politique-de-confidentialite']]),
    beton: new Map([['fr', 'politique-de-confidentialite']]),
    pintura: new Map([['es', 'politica-privacidad']]),
};
